import captionService from "CaptionService";

export const drawer: Record<string, (params?: unknown[]) => string> = {
  copyLink: () => captionService.getString("8ba14c6e-72a7-4224-a668-fd6d4f1668f8", "Copy link"),
  entityActions: () => captionService.getString("bad4a1cd-22e6-47f8-85d2-268e58d4f6fc", "Entity actions"),
  openInNewTab: () => captionService.getString("2465834d-ea9a-4d89-b390-63f0768a14f7", "Open in new tab"),
  toggleFavorite: () => captionService.getString("ca67fedc-899d-4c92-bde0-4d240850adda", "Toggle favorite"),
};
